import { render, staticRenderFns } from "./accountledger.vue?vue&type=template&id=12635b9b"
import script from "./accountledger.vue?vue&type=script&lang=js"
export * from "./accountledger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports